<template>
  <li v-if="!childrenLinks && isHeader" :class="{ headerLink: true, className }">
    <router-link :to="link" class="sidebar-link">
      <span class="icon">
        <b-icon :icon="iconName"></b-icon>
      </span>
      {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
      <b-badge v-if="badge" variant="primary" pill>{{ badge }}</b-badge>
    </router-link>
  </li>
  <li v-else-if="childrenLinks" :class="{ headerLink: true, className }">
    <!-- 사이드 메뉴 아코디언 추가 시작 -->
    <!-- <a class="sidebar-link" v-b-toggle.accordion-1> -->
    <a class="not-collapsed">
      <!-- 전체가 보여야할 시 
         1. v-b-toggle.accordion-1 삭제(컨트롤 불가)
         2. 상단 sidebar-link뒤에 not-collapsed 추가 ex)sidebar-link not-collapsed
         3. 하단 sidebar_sub 뒤에 show 추가 ex)sidebar_sub show
    -->
      <!-- v-b-toggle.accordion-숫자 값으로 하단 id값(내용) 컨트롤 -->
      <span data-v-56fc6690="" class="icon"><i data-v-56fc6690="" class="fi flaticon-layers"></i></span> {{ header }}
    </a>
    <b-collapse id="accordion-1" class="sidebar_sub show">
      <b-card>
        <template v-for="(link, index) in childrenLinks">
          <router-link :to="index !== 'menu' && link.link" :index="link.index" :key="index"> ㄴ {{ link.header }} </router-link>
        </template>
        <!-- <a v-for="link in childrenLinks" :href="link.link" :index="link.index" :key="link.link">{{ link.header }}</a> -->
      </b-card>
    </b-collapse>
    <!-- //사이드 메뉴 아코디언 추가 끝 -->
    <!-- <div @click="() => togglePanelCollapse(link)">
      <router-link :to="link" event="" class="d-flex sidebar-link">
        <span class="icon">
          <i :class="fullIconName"></i>
        </span>
        {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="ml-1 headerLabel">{{ label }}</sup>
        <div :class="{ caretWrapper: true, carretActive: isActive }">
          <i class="fa fa-angle-left" />
        </div>
      </router-link>
    </div>
    <b-collapse :id="'collapse' + index" :visible="isActive">
      <ul class="sub-menu">
        <NavLink v-for="link in childrenLinks" :activeItem="activeItem" :header="link.header" :index="link.index" :link="link.link" :childrenLinks="link.childrenLinks" :key="link.link" />
      </ul>
    </b-collapse> -->
  </li>
  <!-- <li v-else>
    <router-link :to="index !== 'menu' && link">
      {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
    </router-link>
  </li> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NavLink',
  props: {
    badge: { type: String, dafault: '' },
    header: { type: String, default: '' },
    iconName: { type: String, default: '' },
    headerLink: { type: String, default: '' },
    link: { type: String, default: '' },
    childrenLinks: { type: Array, default: null },
    className: { type: String, default: '' },
    isHeader: { type: Boolean, default: false },
    deep: { type: Number, default: 0 },
    activeItem: { type: String, default: '' },
    label: { type: String },
    labelColor: { type: String, default: 'warning' },
    index: { type: String },
    permission: { type: Array, default: null },
    menuId: { type: String, default: null }
  },
  data() {
    return {
      headerLinkWasClicked: true
    }
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive']),
    togglePanelCollapse(link) {
      this.changeSidebarActive(link)
      this.headerLinkWasClicked = !this.headerLinkWasClicked || !this.activeItem.includes(this.index)
    }
  },
  computed: {
    ...mapGetters('authentication', ['getUserInfo', 'getCurrentMenuInfo', 'getIsReadOnlyInfo', 'getIsReadWriteInfo', 'getIsDownloadInfo']),
    fullIconName() {
      return `fi ${this.iconName}`
    },
    isActive() {
      return this.activeItem && this.activeItem.includes(this.index) && this.headerLinkWasClicked
    }
  }
}
</script>

<style src="./NavLink.scss" lang="scss" scoped />
